export const PREFERRED_DEFAULT_BUILDING = "posthuset";

/**
 * The building a user lands in when the URL names none they can open: the
 * preferred default if they belong to it, otherwise their first building.
 * Shared by BuildingUserProvider and the building contact route (FUN-1338) so
 * the two never disagree.
 */
export function pickDefaultBuilding(buildingIds: string[]): string | undefined {
  return buildingIds.includes(PREFERRED_DEFAULT_BUILDING)
    ? PREFERRED_DEFAULT_BUILDING
    : buildingIds[0];
}
